import { Controller } from "@hotwired/stimulus"
import { autoUpdate, computePosition, flip, offset, shift } from "@floating-ui/dom"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    this.updatePosition = this.updatePosition.bind(this)
  }

  disconnect() {
    this.hide()
  }

  show() {
    this.contentTarget.style.display = "block"
    this.cleanupAutoUpdate = autoUpdate(this.triggerTarget, this.contentTarget, this.updatePosition)
    this.updatePosition()
  }

  hide() {
    if (this.cleanupAutoUpdate) {
      this.cleanupAutoUpdate()
      this.cleanupAutoUpdate = null
    }

    this.contentTarget.style.display = "none"
  }

  async updatePosition() {
    const { x, y } = await computePosition(this.triggerTarget, this.contentTarget, {
      placement: "top",
      strategy: "fixed",
      middleware: [
        offset(8),
        flip({ padding: 8 }),
        shift({ padding: 8 })
      ]
    })

    Object.assign(this.contentTarget.style, {
      left: `${x}px`,
      top: `${y}px`,
      right: "auto",
      bottom: "auto"
    })
  }
}
